import logo from '../logo-rh-fenix-transparente.png';

function Login({
  loginEmail,
  setLoginEmail,
  loginSenha,
  setLoginSenha,
  mensagemLogin,
  fazerLogin
}) {

  return (
    <div className="login-page">

      <div className="login-box">

        <img
          src={logo}
          alt="RH Fênix"
          className="login-logo"
        />

        <h1>Login Corporativo</h1>

        <p>
          Acesse o ambiente seguro do RH Fênix Enterprise.
        </p>

        <form
          className="login-form"
          onSubmit={fazerLogin}
        >

          <input
            type="email"
            placeholder="E-mail corporativo"
            value={loginEmail}
            onChange={(e) =>
              setLoginEmail(e.target.value)
            }
            required
          />

          <input
            type="password"
            placeholder="Senha"
            value={loginSenha}
            onChange={(e) =>
              setLoginSenha(e.target.value)
            }
            required
          />

          <button type="submit">
            Entrar
          </button>

        </form>

        {mensagemLogin && (
          <div className="login-message">
            {mensagemLogin}
          </div>
        )}

      </div>

    </div>
  );
}

export default Login;
